export default "__VITE_ASSET__a7301e5a__"